module.exports = __webpack_public_path__ + "img/partner7.d5a11980.png";